import React, {PureComponent, HTMLAttributes, CSSProperties} from 'react'
import PropTypes from 'prop-types'
import cxs from 'cxs/component'
import Theme from 'Theme'
import {Icon} from 'elements'

interface Props extends HTMLAttributes<HTMLSelectElement> {
  value?: string | number
  options: {
    name: string
    value?: string | number
  }[]
  label?: string
  placeholder?: string
  underline?: boolean
}

class Select extends PureComponent<Props, object> {
  static defaultProps = {
    underline: true
  }

  render() {
    const {
      value,
      options,
      label,
      placeholder,
      underline,
      onChange,
      ...props
    } = this.props
    const unfolded = value ? true : false
    return (
      <Wrapper {...props} underline={underline} label={label}>
        {label ? <Label unfolded={unfolded}>{label}</Label> : null}
        <StyledSelect defaultValue={value} label={label} onChange={onChange}>
          {placeholder ? <option value={undefined} /> : null}
          {options.map(option => (
            <option key={option.name} value={option.value}>
              {option.name}
            </option>
          ))}
        </StyledSelect>
        <StyledIcon name="arrow" />
      </Wrapper>
    )
  }
}

export default Select

const height =
  Math.ceil(Theme.common.size.font * Theme.common.size.lineHeight) +
  Theme.common.size.font +
  1 +
  'px'

const Wrapper = cxs('div')(
  ({underline, label}) =>
    ({
      position: 'relative',
      margin: Theme.size.space[1],
      // margin: `auto ${Theme.size.space[1]}`,
      height: label ? height : undefined,
      ...underline
        ? {
            borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`
          }
        : undefined
    } as CSSProperties)
)

Wrapper.propTypes = {
  underline: PropTypes.bool,
  label: PropTypes.string
}

const Label = cxs('label')(
  ({unfolded}) =>
    ({
      position: 'absolute',
      display: 'block',
      height: Theme.fontSize.regular,
      fontSize: unfolded ? Theme.fontSize.small : Theme.fontSize.regular,
      color: Theme.color.placeholder,
      transform: `translateY(${unfolded ? 0 : 0})`,
      zIndex: -1,
      transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
    } as CSSProperties)
)

Label.propTypes = {
  unfolded: PropTypes.bool
}

const StyledSelect = cxs('select')(
  ({label}) =>
    ({
      width: '100%',
      height: '100%',
      paddingRight: Theme.size.space[3],
      ...label ? {paddingTop: Theme.fontSize.regular, height} : null
    } as CSSProperties)
)

StyledSelect.propTypes = {
  label: PropTypes.string
}

const StyledIcon = cxs(Icon)({
  position: 'absolute',
  right: 0,
  bottom: 0,
  transform: 'rotate(90deg)',
  padding: 0,
  zIndex: -1
} as CSSProperties)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/elements/Select.tsx